export default {
  badRequest: 'There was a problem with the request.',
  notFound: 'We could not find this.',
  internalServerError: "Something went wrong. Don't worry, is on us. Try again later."
};
